import Heading from 'components/Heading/Heading'
import { _renderLoading } from 'components/SectionSliderProductCard'
import { RichTextFormat } from 'containers/ProductDetailPage/AccordionInfo'
import parse from 'html-react-parser'
import { useSelector } from 'react-redux'
import { useGetPoliticsQuery } from 'store/api/politicsApi'


const CommonPoliticsPage = ({politic, title}:{politic:string, title:string}) => {
    const college = useSelector((state) => state.college.college)
    const {data, isLoading} = useGetPoliticsQuery({school_id: college?.id, type: politic})
  return (
    <div className='container my-16'>
        <Heading desc={""}>
            {title}
        </Heading>
        {
          isLoading
          ?_renderLoading()
          :<RichTextFormat>
            {data?.content ? parse(data?.content) : "Aún no hay nada que mostrar"}
          </RichTextFormat>
        }
    </div>
  )
}
export default CommonPoliticsPage;